// css:
import './styles/sass/dlp.lib.scss';
import './styles/sass/action-image.scss';
import './styles/sass/claim-element.scss';
import './styles/sass/content-size.scss';
import './styles/sass/cross-selling.scss';
import './styles/sass/debug.scss';
import './styles/sass/default-image.scss';
import './styles/sass/default-style-elements.scss';
import './styles/sass/description.scss';
import './styles/sass/error.scss';
import './styles/sass/exception.scss';
import './styles/sass/eye-catcher.scss';
import './styles/sass/fsiview.scss';
import './styles/sass/icn.scss';
import './styles/sass/modal-dialog.scss';
import './styles/sass/module-groups.scss';
import './styles/sass/order-link.scss';
import './styles/sass/price.scss';
import './styles/sass/text-module.scss';
import './styles/sass/video.scss';

import './styles/sass/templates/1a_ai_3dmi_cs.scss';
import './styles/sass/templates/1a_ai_3dmi_cs.lib.scss';
import './styles/sass/templates/1b_2xai_3dmi.scss';
import './styles/sass/templates/1b_2xai_3dmi.lib.scss';
import './styles/sass/templates/2_ai_3dmi_tm.scss';
import './styles/sass/templates/2_ai_3dmi_tm.lib.scss';
import './styles/sass/templates/3_ai_sc_mi.scss';
import './styles/sass/templates/3_ai_sc_mi.lib.scss';
import './styles/sass/templates/4_ai_s3d.scss';
import './styles/sass/templates/4_ai_s3d.lib.scss';
import './styles/sass/templates/5_ai_3dmi_video.scss';
import './styles/sass/templates/5_ai_3dmi_video.lib.scss';
import './styles/sass/templates/6_ai_3dmi_claim.scss';
import './styles/sass/templates/6_ai_3dmi_claim.lib.scss';
import './styles/sass/templates/7a_ai_3dmi.scss';
import './styles/sass/templates/7a_ai_3dmi.lib.scss';
import './styles/sass/templates/7b_2xai_3dmi.scss';
import './styles/sass/templates/7b_2xai_3dmi.lib.scss';
import './styles/sass/templates/8_3dmi_cs.scss';
import './styles/sass/templates/8_3dmi_cs.lib.scss';
import './styles/sass/templates/9_3dmi.scss';
import './styles/sass/templates/9_3dmi.lib.scss';
import './styles/sass/templates/content_ai_claim.scss';
import './styles/sass/templates/content_ai_claim.lib.scss';
import './styles/sass/templates/cross-article.lib.scss';
import './styles/sass/templates/crossArticle-actionImage.scss';
import './styles/sass/templates/crossArticle-threeDview.scss';
import './styles/sass/templates/crossArticle-withImage.scss';
import './styles/sass/templates/defaultImage-threeDview.scss';

// scripts:
import './scripts/typescript/video-component';
import './scripts/typescript/text-module';
import './scripts/typescript/sliced-3d';
import './scripts/typescript/queryParameterTools';
import './scripts/typescript/modal-scrollLock';
import './scripts/typescript/modal-Dialog';
import './scripts/typescript/image-loader';
import './scripts/typescript/exception';
import './scripts/typescript/debug';
import './scripts/typescript/languageFragmentsTranslation';
import './scripts/typescript/orderModalController';